import { FetchCarsFxProps, getCarsByDealerIds } from '../../api/cars'
import { FilterSection, FilterValues } from '../../features/filter/types'
import { findUncheckedDealerInFilters } from '../find-unchecked-dealer'

// ищем дилера, который не выбран ещё в фильтре и делаем проверку, есть ли у него машины
// если машины есть возвращаем айдшник данного дилера
export const getUncheckedDealerWithCars = async (
  dealersSection: FilterSection | undefined,
  listRequestData: FetchCarsFxProps,
  filtersList: FilterValues
) => {
  const currentDealers: string[] = []
  const totalLength = dealersSection?.groups.reduce((acc, group) => acc + group.fields.length, 0) || 0

  for (let i = 0; i < totalLength; i++) {
    currentDealers.push(findUncheckedDealerInFilters(dealersSection, currentDealers))

    const response = await getCarsByDealerIds(listRequestData, filtersList, currentDealers)

    if (response.total_count) {
      return currentDealers?.pop() || ''
    }
  }

  return ''
}
